module.exports = __webpack_public_path__ + "assets/img/15.420a328a.png";